<style lang="scss" scoped>

</style>

<template>
    <div class="b-faq__list-item">
        <div :class="{ _active: shown }" @click="toggle()" class="b-faq__list-item_header s-faq-item-header">
            <div class="b-faq__list-item_header-icon">
                <img v-once :src="icon" :alt="title">
            </div>
            <div v-once class="b-faq__list-item_header-title">{{ title }}</div>
            <div class="b-faq__list-item_header-arrow">
                <img src="/img/faq/arrow.svg" alt="">
            </div>
        </div>

        <vue-slide-up-down :active="shown">
            <div class="b-faq__list-item_content s-faq-item-content">
                <slot />
            </div>
        </vue-slide-up-down>
    </div>
</template>

<script>
export default {

    props: [
        'icon',
        'title'
    ],

    data() {
        return {
            shown: false
        }
    },

    methods: {
        toggle() {
            this.shown ? this.hide() : this.show()
        },

        show() {
            this.shown = true
            this.$emit('show')
        },

        hide() {
            this.shown = false
        },
    }
}
</script>
